import styled from 'styled-components';

export const HelpBlogLayoutContainer = styled.div`
	.image {
		overflow: hidden;
		height: 160px;
		background: #064bc9;
		background: linear-gradient(
			40deg,
			rgba(6, 75, 201, 1) 0%,
			rgba(6, 75, 201, 1) 42%,
			rgba(188, 214, 250, 1) 100%
		);

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
`;
